import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from 'react-bootstrap/Spinner';
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import StudentGroupDropDown from "../Shared/StudentGroupDropDown";
import StudentStatusDropDown from "../Shared/StudentStatusDropDown";
import { toast, ToastContainer } from 'react-toastify';
import { NavLink } from "react-router-dom";
import moment from "moment";
import Pagination from "../General/Pagination";
import Dropdown from 'react-bootstrap/Dropdown';
import { Form } from 'react-bootstrap';
import FeeSystemMenu from "./FeeSystemMenu";
import FeeTypesDropDown from "../Shared/FeeTypesDropDown";
import { scrollToTop } from '../Shared/ScrollOnTop';
import RightsCheck from '../General/RightsCheck';

function AddOtherDuesChallan(props) {

    const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
    const [UserID, setUserID] = useState(localStorage.getItem("ID"));
    const [MemberType, setMemberType] = useState(localStorage.getItem("MemberType"));
    //const [DefaultSession, setDefaultSession] = useState(localStorage.getItem("DefaultSession"));

    const [showFilters, setShowFilters] = useState(true);

    const [loading, setLoading] = useState(false);
    const [Button_Loading, setButton_Loading] = useState(false);
    const [listOfLedger, setLedger] = useState([]);
    const [validated, setValidated] = useState(false);

    // pagination 
    const [pageNo, setPageNo] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);

    const [WingId, setWingId] = useState(0);
    const [SessionId, setSessioinId] = useState(localStorage.getItem("DefaultSession"));
    const [ClassId, setClassId] = useState(0);
    const [SectionID, setSectionID] = useState(0);
    const [GroupId, setGroupId] = useState(0);
    const [StudentStatusType, setStudentStatusType] = useState(0);
    const [isUpdated, setIsUpdated] = useState(false);

    const [Registration_No, SetRegistrationNo] = useState("");
    const [StudentID, setStudentID] = useState(0);
    const [Keywords, setKeywords] = useState("");
    const [Status_Type_Id, SetStatusTypeId] = useState(0);
    const [OrderBy, setOrderBy] = useState(0);

    const [DuesType, setDuesType] = useState(0);
    /** When true, server soft-deletes the current open monthly challan, bumps YYMM sequence, clones AD lines, then adds the due. False = append line (same challan no.; blocked if on bank scroll). */
    const [replaceMonthlyChalan, setReplaceMonthlyChalan] = useState(true);

    const now = new Date();
    const [InvoiceMonth, setInvoiceMonth] = useState(now.getMonth() + 1);
    const [InvoiceYear, setInvoiceYear] = useState(now.getFullYear());

    const [selectedStudents, setselectedStudents] = useState([]);
    const [validatedPromote, setValidatedPromote] = useState(false);

    useEffect(() => {

        if(WingId == "0")
        {
            setClassId("0");
            setSectionID("0");
        }
        if(ClassId == "0")
        {
            setSectionID("0");
        }

        document.title = "Attach Other Dues (Challan / AD Ledger)";

        setIsUpdated(false);
        setLoading(true);

        const data = {
            AccessKey: AccessKey,
            UserID: UserID,
            MemberType: MemberType,
            pageNo: pageNo,
            pageSize: pageSize,
            SessionID: parseInt(SessionId, 10) || 0,
            Wing_Id: parseInt(WingId, 10) || 0,
            Class_Id: parseInt(ClassId, 10) || 0,
            Section_Id: parseInt(SectionID, 10) || 0,
            Registration_No: Registration_No,
            Student_ID: StudentID,
            Keywords: Keywords,
            Status_Type_Id: parseInt(Status_Type_Id, 10) || 0,
            Group_Id: parseInt(GroupId, 10) || 0,
            OrderBy: OrderBy === 0 || OrderBy === "0" ? "Student_Name" : OrderBy,
        };

         //console.log(data);

        var api_config = {
            method: 'post',
            url: config.base_url + 'Student/SearchStudents',
            headers: {
                'Content-Type': 'application/json'
            },
            data: data
        };


        axios(api_config)
            .then(function (response) {
                //console.log(response.data);
                setLedger(response.data.ListofRecords);
                setLoading(false);
                setTotalRecords(response.data.totalRecords);

            })
            .catch(function (error) {
                //console.log(error);
            });

    }, [pageNo, pageSize, SessionId, WingId, ClassId, SectionID, Registration_No, StudentID, Keywords, Status_Type_Id, GroupId, OrderBy]);

    const handlePageChange = (page) => {
        setPageNo(page);
    };
 
    const [selectAll, setSelectAll] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);


    const toggleSelectAll = () => {
        setSelectAll(!selectAll);
        if (!selectAll) {
            setSelectedItems(listOfLedger.map(item => item.Student_ID));
        } else {
            setSelectedItems([]);
        }
    };

    const toggleSelectItem = (itemId) => {
        if (selectedItems.includes(itemId)) {
            setSelectedItems(selectedItems.filter(id => id !== itemId));
        } else {
            setSelectedItems([...selectedItems, itemId]);
        }
    };

    const openChalanHeadPrintTabs = (headIds) => {
        if (!headIds || !headIds.length) return;
        const chunkSize = 50;
        for (let i = 0; i < headIds.length; i += chunkSize) {
            const chunk = headIds.slice(i, i + chunkSize).join(",");
            window.open(
                `/students/PrintChalanHead/?ChalanHeadIds=${encodeURIComponent(chunk)}`,
                "_blank",
                "noopener,noreferrer"
            );
        }
    };

    /** Print generated monthly challan for the challan month/year selected on this form (tblChalanHead / tblADLedger). */
    const printChalanForStudentRow = (studentId) => {
        const sid = parseInt(studentId, 10);
        if (!sid || Number.isNaN(sid)) {
            toast.error("Invalid student id.", { position: toast.POSITION.TOP_RIGHT });
            return;
        }
        const data = {
            AccessKey: AccessKey,
            UserID: parseInt(UserID, 10) || 0,
            MemberType: MemberType || "Admin",
            SelectedStudents: [sid],
            InvoiceMonth: InvoiceMonth,
            InvoiceYear: InvoiceYear,
        };
        axios({
            method: "post",
            url: config.base_url + "ChallanFeeSystem/GetMonthlyChalanHeadIdsForPrint",
            headers: { "Content-Type": "application/json" },
            data,
        })
            .then(function (response) {
                if (response.data.status_code !== 1) {
                    toast.error(
                        response.data.status_message ||
                            "No monthly challan for this student for the selected month.",
                        { position: toast.POSITION.TOP_RIGHT }
                    );
                    return;
                }
                const raw =
                    response.data.chalan_head_ids ||
                    response.data.ChalanHeadIds ||
                    [];
                if (!raw.length) {
                    toast.error("No challan ids returned.", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    return;
                }
                openChalanHeadPrintTabs(raw);
            })
            .catch(function () {
                toast.error("Network error.", { position: toast.POSITION.TOP_RIGHT });
            });
    };

    const renderLedger = () => {

        if (listOfLedger.length > 0) {
            return (
                listOfLedger.map((item, index) => {
                    return (
                        <tr key={index}>
                            {/* <td>
                                <div className="form-check">
                                    <input key={item.Student_ID} data-type-id={item.Student_ID} className="form-check-input checkStudent" type="checkbox" value={item.Student_ID} />
                                </div>
                            </td> */}
                            <td>
                                <div className="form-check">
                                    <input
                                        key={item.Student_ID}
                                        data-type-id={item.Student_ID}
                                        className="form-check-input checkStudent"
                                        type="checkbox"
                                        value={item.Student_ID}
                                        checked={selectedItems.includes(item.Student_ID)}
                                        onChange={() => toggleSelectItem(item.Student_ID)}
                                    />
                                </div>
                            </td>
                            <td>{item.Registration_No}</td>
                            <td>{item.Student_Name}</td>
                            <td>{item.Father_Name}</td>
                            <td>{moment(item.Date_Of_Birth).format('DD/MM/YYYY')}</td>
                            <td>{moment(item.Date_Of_Joining).format('DD/MM/YYYY')}</td>
                            <td>{item.Contact_Mobile}</td>
                            <td>{item.SelectedClass.SelectedWing.Wing_Name}</td>
                            <td>{item.SelectedClass.Class_Name}</td>
                            <td>{item.SelectedSection.Section_Name}</td>
                            <td>
                                <div className="status">
                                    {
                                        item.Concession_Rule_ID > 1 &&
                                        <span className="green"><i className="ri-percent-fill"></i></span>
                                    }
                                    {
                                        item.Current_Route_Id > 0 &&
                                        <span className="red"><i className="ri-bus-2-fill"></i></span>
                                    }

                                    <span className="blue"><i className="ri-emotion-normal-line"></i></span>

                                </div>
                            </td>
                            <td>
                                <ul className="inline-action">
                                    <li><NavLink to={'/Students/EditStudent/' + item.Student_ID} className=" green"><i className="ri-edit-line"></i></NavLink></li>
                                    <li>
                                        <a
                                            href="#print-challan"
                                            className="blue"
                                            title="Print monthly challan for selected challan month (generated — tblChalanHead / tblADLedger)"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                printChalanForStudentRow(item.Student_ID);
                                            }}
                                        >
                                            <i className="ri-printer-line"></i>
                                        </a>
                                    </li>
                                    <li><NavLink to={'/Students/StudentLedger/' + item.Student_ID} className="red"><i className="ri-pages-line"></i></NavLink></li>
                                </ul>
                            </td>
                        </tr>
                    )
                })
            )
        }
        else {
            return (
                <tr>
                    <td colSpan={12}><h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>No Data Found</h4></td>
                </tr>
            )
        }

    }

    const handleSubmit = (event) => {
        setButton_Loading(true);
        event.preventDefault();
        event.stopPropagation();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();

        }
        else {
            const data = {
                AccessKey: AccessKey,
                UserID: UserID,
                MemberType: MemberType,
                pageNo: pageNo,
                pageSize: pageSize,
                SessionID: parseInt(SessionId, 10) || 0,
                Wing_Id: parseInt(WingId, 10) || 0,
                Class_Id: parseInt(ClassId, 10) || 0,
                Section_Id: parseInt(SectionID, 10) || 0,
                Registration_No: Registration_No,
                Student_ID: parseInt(StudentID, 10) || 0,
                Keywords: Keywords,
                Status_Type_Id: parseInt(Status_Type_Id, 10) || 0,
                Group_Id: parseInt(GroupId, 10) || 0,
                OrderBy: OrderBy === 0 || OrderBy === "0" ? "Student_Name" : OrderBy,
            };

            //console.log(data);

            var api_config = {
                method: 'post',
                url: config.base_url + 'Student/SearchStudents',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };


            axios(api_config)
                .then(function (response) {
                    //console.log(response.data);
                    setLedger(response.data.ListofRecords);
                    setLoading(false);
                    setButton_Loading(false);
                    setTotalRecords(response.data.totalRecords);

                })
                .catch(function (error) {
                    //console.log(error);
                });


        }

        setValidated(true);
    }


    //handlePromote
    const handlePromote = (event) => {

        event.preventDefault();
        event.stopPropagation();

        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();

        }
        else {
            setButton_Loading(true)

            const duesTypeRadio = form.querySelector('input[name="DuesType"]:checked');
            const duesTypeVal = duesTypeRadio ? parseInt(duesTypeRadio.value, 10) : 0;
            const feeTypeVal = parseInt(form.FeeTypeId.value, 10);
            const amountVal = parseInt(form.amount.value, 10);

            if (duesTypeVal === 1 && (!selectedStudents || selectedStudents.length === 0)) {
                toast.error("Select at least one student from the list.", { position: toast.POSITION.TOP_RIGHT });
                setButton_Loading(false);
                setValidatedPromote(true);
                return;
            }
            if (!feeTypeVal || Number.isNaN(feeTypeVal)) {
                toast.error("Please select a dues / fee type.", { position: toast.POSITION.TOP_RIGHT });
                setButton_Loading(false);
                setValidatedPromote(true);
                return;
            }
            if (Number.isNaN(amountVal)) {
                toast.error("Enter a valid amount.", { position: toast.POSITION.TOP_RIGHT });
                setButton_Loading(false);
                setValidatedPromote(true);
                return;
            }

            const data = {
                AccessKey: AccessKey,
                UserID: parseInt(UserID, 10),
                MemberType: MemberType,
                SelectedStudents: duesTypeVal === 1 ? selectedStudents : [],
                DuesType: duesTypeVal,
                FeeTypeId: feeTypeVal,
                Amount: amountVal,
                Description: form.description.value,
                Class_Id: parseInt(ClassId, 10) || 0,
                Section_Id: parseInt(SectionID, 10) || 0,
                InvoiceMonth: InvoiceMonth,
                InvoiceYear: InvoiceYear,
                ReplaceMonthlyChalanWhenAttachingOtherDues: replaceMonthlyChalan
            };

            //console.log(data);

            var api_config = {
                method: 'post',
                url: config.base_url + 'ChallanFeeSystem/AttachOtherDuesChallan',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: data
            };

            //console.log(data);

            axios(api_config)
                .then(function (response) {
                    //console.log(response.data);
                    if (response.data.status_code == 1) {

                        toast.success(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setIsUpdated(true);
                        setButton_Loading(false)
                    }
                    else {
                        toast.error(response.data.status_message, {
                            position: toast.POSITION.TOP_RIGHT
                        });
                    }

                    setLoading(false);
                    setButton_Loading(false)


                })
                .catch(function (error) {
                    const msg = (error.response && error.response.data && error.response.data.status_message)
                        ? error.response.data.status_message
                        : (error.message || "Request failed.");
                    toast.error(msg, { position: toast.POSITION.TOP_RIGHT });
                    setButton_Loading(false);
                });


        }

        setValidatedPromote(true);
    }

    return (
        <>
            <RightsCheck />
            <FeeSystemMenu />
            <ToastContainer />
            <div className="container body-content">
                <div className="page-head">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-6">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><NavLink to="/Dashboard">Dashboard</NavLink></li>
                                        <li className="breadcrumb-item"><NavLink to="/FeeSystem/FeeSystemDashboard">Fee System</NavLink></li>
                                        <li className="breadcrumb-item active" aria-current="page">Attach Dues (Challan)</li>
                                    </ol>
                                </nav>
                                <div className="page-title">Attach Other Dues / Fines — Challan mode</div>
                                <p className="text-muted small mb-0 mt-1">Posts to <strong>tblChalanHead</strong> and <strong>tblADLedger</strong> only (not <strong>tblStudentLedger</strong>). When an open monthly challan already exists, the default is a full amendment: previous head is soft-deleted with status Deleted, sequence in the challan number increases, lines are copied to the new head, then your due is added. Challans already on bank scroll cannot be changed.</p>
                            </div>

                            <div className="col-md-6">
                                <div className="page-right-actions">
                                    <NavLink to="/students/AddStudent" className="button button-white button-icon">
                                        Add Students
                                        <i className="ri-add-fill"></i>
                                    </NavLink>
                                    <button
                                        onClick={() => {
                                            setShowFilters((prevIsActive) => !prevIsActive);
                                        }}
                                        className="button button-white button-icon">
                                        {showFilters ? 'Hide Filters' : 'Show Filters'}
                                        <i className="ri-filter-3-line"></i>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div className={`collapse ${showFilters ? 'show' : ''} `} id="collapseFilteres">
                    <Form noValidate validated={validated} onSubmit={handleSubmit}>
                        <div className="page-content">
                            <div className="container">
                                <div className="card mb-2">
                                    <div className="card-body p-md-4">
                                        <div className="row align-items-end gy-3">
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Select Session:</label>
                                                    <select className="form-select" onChange={(e) => setSessioinId(e.target.value)} name="SessionID">
                                                        <option value="0">---All---</option>
                                                        <SessionsDropDown selectedSession={SessionId} />
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Select Wing:</label>
                                                    <select name="WingId" onChange={(e) => {setWingId(e.target.value); setClassId(0); }} className="form-select">
                                                        <option value="0">---All---</option>
                                                        <WingsDropDown />
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Select Class:</label>
                                                    <select className="form-select" onChange={(e) => {setClassId(e.target.value); setSectionID(0);}} name="ClassId">
                                                        <option value="0">Please Select</option>
                                                        {
                                                            SessionId != 0 && WingId != 0 &&
                                                            <ClassesDropDown SessionID={SessionId} WingID={WingId} />
                                                        }

                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Select Section:</label>
                                                    <select className="form-select" onChange={(e) => setSectionID(e.target.value)} name="Section_Id">
                                                        <option value="0">Please Select</option>
                                                        {
                                                            ClassId !== 0 &&
                                                            <SectionDropDown ClassID={ClassId} />
                                                        }

                                                    </select>
                                                </div>
                                            </div>


                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Registration No:</label>
                                                    <input type="text" name="Reg_No" onChange={(e) => SetRegistrationNo(e.target.value)} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Student Id:</label>
                                                    <input type="text" name="Student_ID" onChange={(e) => setStudentID(e.target.value)} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Keywords:</label>
                                                    <input type="text" name="Keywords" onChange={(e) => setKeywords(e.target.value)} className="form-control" />
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Student Status:</label>
                                                    <select className="form-select" onChange={(e) => SetStatusTypeId(e.target.value)} name="statustype">
                                                        <option value="">---All---</option>
                                                        {
                                                            <StudentStatusDropDown />
                                                        }

                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Select Group:</label>
                                                    <select className="form-select" onChange={(e) => setGroupId(e.target.value)} name="groupName">
                                                        <option value="">---All---</option>
                                                        {
                                                            <StudentGroupDropDown />

                                                        }

                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <div className="form-group">
                                                    <label>Order by:</label>
                                                    <select name="OrderBy" value={OrderBy === 0 ? "Student_Name" : OrderBy} onChange={(e) => setOrderBy(e.target.value)} className="form-select">
                                                        <option value="Student_Name">Student Name</option>
                                                        <option value="Registration_No">Registration No</option>
                                                        <option value="Wing_Name">Wing Name</option>
                                                        <option value="Class_Name">Class</option>
                                                        <option value="Student_ID">Student ID Asc</option>
                                                        <option value="Student_ID desc">Student ID Desc</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <div className="col-md-2 offset-md-4">
                                                <div className="form-group text-center">
                                                    {
                                                        Button_Loading ?
                                                            <Spinner animation="border" className="mt-4" role="status"></Spinner>
                                                            :
                                                            <button type="submit" value="Search" onClick={handleSubmit} className="button button-primary mt-4 w-100">Search</button>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
                <div className="page-content">
                    <div className="container">
                        <div className="card">
                            <div className="card-body">
                                {/* <div className="text-end mb-2 me-3">
                                    <b>{{totalRecords}} &nbsp; Records Found!</b>

                                </div> */}
                                <table className="table table-theme">
                                    <thead>
                                        <tr>
                                            <td>
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input checkStudent"
                                                        type="checkbox"
                                                        value="selectAll"
                                                        checked={selectAll}
                                                        onChange={toggleSelectAll}
                                                    />
                                                </div>
                                            </td>
                                            <th>Reg No</th>
                                            <th>Name</th>
                                            <th>Father Name</th>
                                            <th>DOB</th>
                                            <th>DOJ</th>
                                            <th>Mobile</th>
                                            <th>Wing</th>
                                            <th>Class</th>
                                            <th>Section</th>
                                            <th>Tags</th>
                                            <th className="text-center">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            loading ?
                                                <tr>
                                                    <td className="text-center" colSpan={12}>
                                                        <Spinner animation="border" role="status"></Spinner>
                                                    </td>
                                                </tr>
                                                :
                                                <>
                                                    {renderLedger()}
                                                </>

                                        }

                                    </tbody>
                                </table>
                                {
                                    totalRecords > 10 &&
                                    <div className="pagination-wrap">

                                        <div className="row align-items-center">
                                            <div className="col-md-2 form_default">
                                                <div className="d-flex align-items-center">
                                                    <label className="me-2" style={{ fontSize: "15px" }}>Page Size</label>
                                                    <div className="form-group">
                                                        <select className="form-select"
                                                            style={{ width: "100px" }}
                                                            value={pageSize}
                                                            onChange={(e) => {
                                                                setPageNo(1);
                                                                setPageSize(parseInt(e.target.value, 10));
                                                            }}>
                                                            <option value="10">10</option>
                                                            <option value="20">20</option>
                                                            <option value="50">50</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <Pagination
                                                pageNo={pageNo}
                                                pageSize={pageSize}
                                                totalRecords={totalRecords}
                                                onPageChange={handlePageChange}
                                            />
                                        </div>
                                    </div>

                                }

                            </div>
                        </div>
                    </div>
                    <div className="container">

                        <Form noValidate validated={validatedPromote} onSubmit={handlePromote}>
                            <div className="card mt-2">
                                <div className="card-body p-4">
                                    <div className="row gy-3 align-items-end">
                                        <div className="col-md-4">
                                            <div className="form-check">
                                                <input className="form-check-input" value="1" type="radio" name="DuesType" id="flexRadioDefault1" required defaultChecked />
                                                <label className="form-check-label" htmlFor="flexRadioDefault1">
                                                    Attach Dues to Selected Students
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-check">
                                                <input className="form-check-input" value="2" type="radio" name="DuesType" id="flexRadioDefault2" required />
                                                <label className="form-check-label" htmlFor="flexRadioDefault2">
                                                    Attach Dues to Selected Sesction Only
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-4"></div>
                                        <div className="col-md-4">
                                            <div className="form-check">
                                                <input className="form-check-input" value="3" type="radio" name="DuesType" id="flexRadioDefault3" required />
                                                <label className="form-check-label" htmlFor="flexRadioDefault3">
                                                    Attach Dues to Selected Class Only
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="form-check">
                                                <input className="form-check-input" value="4" type="radio" name="DuesType" id="flexRadioDefault4" required />
                                                <label className="form-check-label" htmlFor="flexRadioDefault4">
                                                    Attach Dues to All Students
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-4"></div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Dues Type:</label>
                                                <select className="form-select" name="FeeTypeId" required>
                                                    <option value="">Please Select</option>
                                                    <FeeTypesDropDown />
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Amount:</label>
                                                <input type="text" name="amount" className="form-control" required />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Description:</label>
                                                <input type="text" name="description" className="form-control" />
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Challan month:</label>
                                                <select className="form-select" value={InvoiceMonth} onChange={(e) => setInvoiceMonth(parseInt(e.target.value, 10))}>
                                                    {[1,2,3,4,5,6,7,8,9,10,11,12].map(m => (
                                                        <option key={m} value={m}>{m}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label>Challan year:</label>
                                                <input type="number" className="form-control" value={InvoiceYear} onChange={(e) => setInvoiceYear(parseInt(e.target.value, 10) || now.getFullYear())} min={2000} max={2100} />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="form-check mt-2">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="replaceChallanSeq"
                                                    checked={replaceMonthlyChalan}
                                                    onChange={(e) => setReplaceMonthlyChalan(e.target.checked)}
                                                />
                                                <label className="form-check-label" htmlFor="replaceChallanSeq">
                                                    New challan number when a monthly challan already exists (recommended): soft-delete previous head, bump YYMM sequence, clone all AD lines, add this due. Uncheck to append on the same challan number only if it is not on bank scroll.
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-md-2 offset-md-1">
                                            {
                                                Button_Loading ?
                                                    <Spinner animation="border" className="ms-4" role="status"></Spinner>
                                                    :
                                                    <button type="submit" className="button button-primary w-100">Attach (Challan)</button>
                                            }
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </Form>
                    </div>

                </div>
            </div>
        </>
    );
}

export default AddOtherDuesChallan;